import React, { useState } from "react";
import { Col_12_8_6_4 } from "../../../../components/col/Col_12_8_6_4";
import LabelValor from "../../../../components/label/LabelValor";
import { Modal, Select } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router";
import { startUpdateServicio } from "../../../../context/actions/concesionariosActions";

const opcionesSucursal = [
  { value: "MATRIZ", label: "MATRIZ" },
  { value: "TOLUCA", label: "TOLUCA" },
  { value: "QUERÉTARO", label: "QUERÉTARO" },
  { value: "MONTERREY", label: "MONTERREY" },
  { value: "TAMAULIPAS", label: "TAMAULIPAS" },
  { value: "DURANGO", label: "DURANGO" },
  { value: "TORREÓN", label: "TORREÓN" },
  { value: "VILLAHERMOSA", label: "VILLAHERMOSA" },
  { value: "CAMPECHE", label: "CAMPECHE" },
  { value: "CANCÚN", label: "CANCÚN" },
  { value: "MÉRIDA", label: "MÉRIDA" },
  { value: "ORIZABA", label: "ORIZABA" },
  { value: "PUEBLA", label: "PUEBLA" },
  { value: "HERMOSILLO", label: "HERMOSILLO" },
  { value: "TIJUANA", label: "TIJUANA" },
  { value: "MEXICALI", label: "MEXICALI" },
  { value: "ACAPULCO", label: "ACAPULCO" },
];

export const Sucursal = () => {
  const [newValor, setNewValor] = useState("");
  const { id } = useParams();
  const dispatch = useDispatch();

  const { concesionariosServicio: c } = useSelector(
    (state) => state.concesionariosReducer
  );
  const s = c?.supervisoria;

  const [openModal, setOpenModal] = useState(false);

  const handleOpen = () => {
    setNewValor(s || "");
    setOpenModal(true);
  };

  const handleOk = () => {
    dispatch(startUpdateServicio({ supervisoria: newValor }, id));
    setOpenModal(false);
  };

  return (
    <>
      <Col_12_8_6_4>
        <LabelValor
          labelStyle={{ cursor: "pointer", textDecoration: "underline dotted" }}
          onClick={handleOpen}
          label="Sucursal"
          valor={s || ""}
        />
      </Col_12_8_6_4>
      <Modal
        title="Sucursal"
        onCancel={() => setOpenModal(false)}
        onOk={handleOk}
        open={openModal}
      >
        <Select
          value={newValor}
          onChange={(value) => setNewValor(value)}
          placeholder="Seleccione sucursal"
          style={{ width: "100%" }}
          allowClear
          options={opcionesSucursal}
        />
      </Modal>
    </>
  );
};
